import React from "react";
import Properties from "./Properties";
import { RxDot } from "react-icons/rx";
import { IoIosPeople } from "react-icons/io";
import { FaBed } from "react-icons/fa";
import { BiArea } from "react-icons/bi";
import {  FaLocationDot } from "react-icons/fa6";
import { LuBedDouble } from 'react-icons/lu'
import { Link } from "react-router-dom";
import { properties } from "../data";
import "./Topproperties.css"

const Topproperties = () => {
  return (
    <section id="topVillas">
      <h1>أفضل العقارات المختارة قوائم حصرية لا يمكنك تفويتها</h1>
      <p>
      هل تبحث عن أفضل الفرص العقارية؟ اطلع على قائمتنا لأفضل العقارات - مجموعة مختارة بعناية من أرقى المنازل والشقق والمساحات التجارية.
      </p>
      <div className="villasContainer">
        {properties.slice(0,3).map((property) => {
          return (
              <Link to={`/properties/${property.id}`} className="card" key={property.id}>
                <img src={property.image} alt={property.name} />
                <div className='card-badge'>
                                  <span className='card-type'>{property.title}</span>
                                </div>
                                <div className='card-content'>
                                  <span className='card-type'>{property.type}</span>
                                  <span className='card-price'>{property.price}</span>
                                  <span className='card-address'>
                                    <FaLocationDot className="card-icon"/>
                                    {property.address}
                                  </span>
                
                                  <div className='card-rooms'>
                                    <span>
                                      <LuBedDouble className='card-icon'/>
                                      {property.bedrooms}
                                    </span>
                                    <span>
                                      <BiArea className='card-icon'/>
                                      {property.size} (sqm)
                                    </span>
                                  </div>
                
                                </div>
              </Link>
          );
        })}
      </div>
    </section>
  );
};

export default Topproperties;
